import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation resources
import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('langue') || 'fr', // default language
    fallbackLng: localStorage.getItem('langue') || 'fr', // fallback language
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
